import { css } from '@emotion/react'

import { colors, typo, whiteAreaCss } from '~/@common/styles'

export const S = {
  page: css`
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 100%;
    width: 100%;
    background: #f0f2f4;
  `,
  progressArea: css`
    display: flex;
    align-items: center;
    background: #f0f2f4;
    height: 48px;
  `,
  progressText: css`
    ${typo.body02};
    font-weight: 700;
    color: var(--Colors-Gray-900);
    span.total {
      font-weight: 400;
    }
  `,
  problemWrap: css`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  `,
  card: css`
    flex: 1;
    display: flex;
    flex-direction: column;
    ${whiteAreaCss};
    ${typo.body01};

    > * + * {
      border-top: 1px solid var(--Colors-Gray-300);
    }
  `,
  cardHeader: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 0 0 70px;
    width: 100%;
    padding: 0 20px;
    background-color: var(--White);
  `,
  cardHeaderLeft: css`
    display: flex;
    align-items: center;
    gap: 10px;
  `,
  problemNumber: css`
    ${typo.body01};
    font-weight: 700;
    color: var(--Colors-Gray-900);
  `,
  answerCountBadge: css`
    display: inline-flex;
    align-items: center;
    height: 30px;
    padding: 4px 12px;
    border-radius: var(--Radius-200);
    background: var(--Colors-Gray-200);
    ${typo.body02};
    font-weight: 700;
    color: var(--Colors-Gray-800);
  `,
  cardHeaderRight: css`
    /* 툴바는 position: absolute — 팝오버(펜 설정 등)가 헤더 높이를 늘리지 않도록 */
    position: relative;
    align-self: stretch;
    min-width: 300px;
  `,
  cardBottom: css`
    position: relative;
    flex: 1 1 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
    background-color: var(--White);
    overflow: hidden;
  `,
  problemArea: css`
    flex: 1 1 100%;
    overflow: auto;
  `,
  emptyMessage: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: var(--Colors-Gray-500);
    ${typo.body02};
  `,
}
